import bearAndRat from '../../asstes/images/sponsers_images/bear-and-rat.png';
import levain from '../../asstes/images/sponsers_images/levain-bakery.png';
import spotAndTango from '../../asstes/images/sponsers_images/spot-and-tango.png';
import superZoo from '../../asstes/images/sponsers_images/superzoo.png';
const sponsors = [
  {image: bearAndRat, name: 'The Bear & The Rat', style: 'bear'},
  {image: levain, name: 'Levain Bakery', style: 'levain'},
  {image: spotAndTango, name: 'Spot & Tango', style: 'spot'},
  {image: superZoo, name: 'SuperZoo', style: 'superzoo'},
];
export default function SponsersView() {
  return <section className="home-sponsors" aria-label="Our supporters">
    <ol className="sponsor-list home-container">{sponsors.map(sponsor => <li key={sponsor.name} className={`sponsor-mark sponsor-mark--${sponsor.style}`}>
      <img src={sponsor.image} alt={sponsor.name} loading="lazy"/>
    </li>)}</ol>
  </section>;
}
